import { render, staticRenderFns } from "./PortfolioMedia.vue?vue&type=template&id=8bf1aa48&scoped=true"
import script from "./PortfolioMedia.vue?vue&type=script&lang=js"
export * from "./PortfolioMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf1aa48",
  null
  
)

export default component.exports